// src/pages/ReportIssue/components/DescriptionSection.js
import React from "react";
import {
    Typography,
    Box,
} from "@mui/material";
import { Description as DescriptionIcon } from "@mui/icons-material";
import RichTextEditor from "../../../components/RichTextEditor/RichTextEditor";

const DescriptionSection = ({ editorState, setEditorState }) => {
    // Add default function if setEditorState is undefined
    const handleEditorChange = (value) => {
        if (setEditorState && typeof setEditorState === 'function') {
            setEditorState(value);
        }
    };

    return (
        <Box mb={4}>
            <Box
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
            >
                <DescriptionIcon sx={{ color: '#3B82F6' }} />
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: '#3A5A78' }}
                >
                    Additional Information
                </Typography>
            </Box>

            <Typography
                variant="body2"
                sx={{ mb: 2, color: '#4B5563' }}
            >
                Please provide as much detail as possible about the issue to help us resolve it quickly.
            </Typography>

            <Box
                sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: '10px',
                    p: 1
                }}
            >
                <RichTextEditor
                    richTextValue={editorState}
                    change={handleEditorChange}
                />
            </Box>
        </Box>
    );
};

// Default props to prevent errors
DescriptionSection.defaultProps = {
    editorState: null,
    setEditorState: () => {}
};

export default DescriptionSection;